import React from 'react';
import {Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography} from "@mui/material"

const headerCellSx = {textTransform: "uppercase", letterSpacing: "0.06em", fontWeight: 600, color: "text.secondary"} as const

function TestRunTableSkeleton() {
    return (
        <TableContainer sx={{overflowX: "auto", bgcolor: "background.paper", border: 1, borderColor: "divider", borderRadius: 2, boxShadow: "none"}}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell padding="checkbox"/>
                        <TableCell sx={{width: "45%"}}>
                            <Typography variant="caption" sx={headerCellSx}>Input</Typography>
                        </TableCell>
                        <TableCell><Typography variant="caption" sx={headerCellSx}>Predicted</Typography></TableCell>
                        <TableCell><Typography variant="caption" sx={headerCellSx}>Expected</Typography></TableCell>
                        <TableCell align="center"><Typography variant="caption" sx={headerCellSx}>Match</Typography></TableCell>
                        <TableCell padding="checkbox"/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {Array.from({length: 8}).map((_, index) => (
                        <TableRow key={index}>
                            <TableCell padding="checkbox"/>
                            <TableCell><Skeleton variant="text"/></TableCell>
                            <TableCell><Skeleton variant="rounded" width={64} height={22}/></TableCell>
                            <TableCell><Skeleton variant="rounded" width={64} height={22}/></TableCell>
                            <TableCell align="center"><Skeleton variant="circular" width={20} height={20} sx={{mx: "auto"}}/></TableCell>
                            <TableCell padding="checkbox"/>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default TestRunTableSkeleton;
